var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-divider'),_c('v-container',{attrs:{"fluid":""}},[_c('router-view'),_c('v-overlay',{attrs:{"color":"white","absolute":"","value":_vm.loading,"z-index":"1000"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }